import { render, staticRenderFns } from "./GoodsReturnDetail.vue?vue&type=template&id=0b97dbe7&"
import script from "./GoodsReturnDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsReturnDetail.vue?vue&type=style&index=0&id=0b97dbe7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports